import { useLocation, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import axios from 'axios'

// Components
import { Rectangle } from '../../components/Rectangle/Rectangle'
import { Input } from '../../components/Input/Input'
import { Button } from '../../components/Button/Button'
import { AnimatedScreenWrapper } from '../../components/AnimatedScreenWrapper/AnimatedScreenWrapper'

// Svg
import { Logo } from '../../assets'

// styles
import './firstName.scss'

// Utils
import { saveTokens } from '../../utils/saveTokens'
import { developmentUrl } from '../../utils/developmentUrl'

interface EmailScreenState {
  email: string
  password: string
}

export const FirstNameScreen = () => {
  let navigate = useNavigate()
  const location = useLocation()
  const { register, handleSubmit } = useForm()

  const onSubmit = handleSubmit(async (data) => {
    const state = location.state as EmailScreenState

    if (state) {
      const body = {
        ...state,
        person: data,
      }

      await axios
        .post(developmentUrl('users'), body)
        .then((response) => {
          if (response.status === 201) {
            saveTokens(response)
            navigate('/first-verification', { state: { email: state.email } })
          }
        })
        .catch((error) => {
          console.error(error.message)
        })
    } else {
      navigate('/email')
    }
  })

  return (
    <div className="full-screen first-name-bg">
      <AnimatedScreenWrapper>
        <div className="grid">
          <div>
            <Logo />
          </div>
          <form onSubmit={onSubmit}>
            <Rectangle>
              <h5 className="secondary-title">What’s your name?</h5>
              <Input type="text" placeholder="first name" {...register('firstName', { required: true })} />
              <Input type="text" placeholder="last name" {...register('lastName', { required: true })} />

              <Button type="submit">submit</Button>
            </Rectangle>
          </form>
        </div>
      </AnimatedScreenWrapper>
    </div>
  )
}
